/**
 * Buscador global — proyectos + tareas de la empresa (scoped + por visibilidad).
 */
import { useQuery } from '@tanstack/react-query';

import { api } from './api';

export interface SearchProject {
  id: string;
  name: string;
  folder_name: string | null;
}
export interface SearchTask {
  id: string;
  title: string;
  project_id: string;
  project_name: string;
  column_name: string | null;
}
export interface SearchResults {
  projects: SearchProject[];
  tasks: SearchTask[];
}

/** Busca (>= 2 caracteres). Devuelve resultados vacíos si la query es corta. */
export function useSearch(query: string) {
  const q = query.trim();
  return useQuery({
    queryKey: ['search', q],
    queryFn: () => api.get<SearchResults>(`/search?q=${encodeURIComponent(q)}`),
    enabled: q.length >= 2,
    staleTime: 15_000,
    retry: false,
  });
}
